<template>
  <v-flex :class="input.mandatory === 'yes' && input.continued === 'yes' ? // if mandatory + continued attr
                  'question-inputs question-inputs-legend pb-0 pt-6' : input.mandatory === 'yes' ? // if mandatory
                  'question-inputs question-inputs-legend py-5 pt-6' : input.continued ? // if continued attr
                  'question-inputs question-inputs-legend pb-0 pt-5' : input.padding ? // if padding attr
                  'question-inputs question-inputs-legend pb-5 pt-0' : 'question-inputs question-inputs-legend py-5'">
    <h3
      :required="input.mandatory === 'yes' ? 'required' : false"
      :aria-required="input.mandatory === 'yes' ? 'required' : false"
      v-html="input[`label_${$i18n.locale}`]"
    ></h3>
    <small
      v-if="input.mandatory === 'yes'"
      v-html="`(${$t('inputs.mandatory')})`"
      class="mandatory-label"
    ></small>
    <small
      v-if="input[`text_${$i18n.locale}`]"
      class="mt-2 mb-0 d-block"
    ><pre v-html="input[`text_${$i18n.locale}`]"></pre></small>
  </v-flex>
</template>

<script>
export default {
  props: {
    input: Object|Array
  }
}
</script>
